import { channelFiltterOptions } from 'json/goods-order-options'
export let filterLabels = [
  {
    label: '预约日期',
    type: 'time-slot',
    value: 'reservationDate',
    clearable: true,
    startName: 'reservationStartTime', // 返回数据时，开始时间的字段名
    endName: 'reservationEndTime' // 返回数据时，结束时间的字段名
  },
  {
    label: '发票状态',
    type: 'select',
    value: 'reservationInvoiceStatus',
    clearable: true,
    options: [
      {
        label: '待审核',
        value: 'PENDING'
      },
      {
        label: '已开票',
        value: 'APPROVED'
      }
    ]
  },
  {
    label: '支付方式',
    type: 'select',
    value: 'channel',
    clearable: true,
    options: channelFiltterOptions
  }
]
export let invoiceStatus = {
  'PENDING': '待审核',
  'APPROVED': '已开票'
}
